export default __webpack_public_path__ + "static/soehne-buch-d04e42c33b17ca7bd8d68a13b46fe8a8.woff2";